import config from './state.config'
import collections from './state.collections'
import misc from './state.misc'

export default () => ({
    ...config,
    ...collections,
    ...misc,
})
